<template>
  <a-modal
    width="600px"
    title="拆分审核任务"
    v-model:visible="visible"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-form
      class="detail-form"
      ref="form"
      :model="form"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }">
      <a-form-item label="任务名称">
        {{ form.name }}
      </a-form-item>
      <a-form-item label="任务总量">
        {{ form.total }}
      </a-form-item>
      <a-form-item label="审核比例">
        <a-input-number
          v-model:value="form.percentage"
          :min="1"
          :max="100"
          :step="1"
          :formatter="value => `${value}%`"
          :parser="value => value.replace('%', '')"
          @change="changeHandle" />
      </a-form-item>
      <a-form-item label="审核数量">
        {{ form.count }}
      </a-form-item>
      <a-form-item label="审核子任务任务量">
        <a-input-number
          v-model:value="form.reviewTaskNum"
          :min="1"
          :max="form.count"
          :step="1"
          @change="form.taskNum = form.reviewTaskNum === 0 ? 0 : Math.ceil(form.count / form.reviewTaskNum)" />
      </a-form-item>
      <a-form-item label="审核子任务数量">
        {{ form.taskNum }}
      </a-form-item>
     <!-- <a-form-item label="选择审核员">
        <a-select
          mode="multiple"
          v-model:value="form.people"
        >
          <a-select-option v-for="item in tableData" :key="item.userId">
            {{item.username}}
          </a-select-option>
         &lt;!&ndash; <a-select-option key="审核员1">
            审核员1
          </a-select-option>
          <a-select-option key="审核员2">
            审核员2
          </a-select-option>
          <a-select-option key="审核员3">
            审核员3
          </a-select-option>&ndash;&gt;
        </a-select>
      </a-form-item>-->
    </a-form>
  </a-modal>
</template>
<script>
import { getDataByPage } from '@/api/dataItem'
import { getUserByPage } from '@/api/user'
import { getSplitTask } from '@/api/task'
export default {
  props: {
    currentItem: {
      type: Object,
      default: () => {}
    },
    addition: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      visible: false,
      form: {
        name: '',
        total: 20000,
        percentage: 100,
        count: 2000,
        people: [],
        reviewTaskNum: 1,
        taskNum: 0
      },
      tableData: []
    }
  },
  methods: {
    open () {
      this.visible = true
      this.$nextTick(() => {
        /*   this.form.name = this.currentItem.name
        this.form.total = this.currentItem.taskNumber ? this.currentItem.taskNumber : 20000
        this.form.count = parseInt(this.form.total * this.form.percentage) */
        // this.getData()
        this.getDataItems()
      })
    },
    getData (pageNum) {
      if (pageNum) this.page.pageNum = pageNum
      getUserByPage({ ...this.page, ...this.form }).then(async res => {
        const resData = res.data.data
        this.total = resData.total
        this.tableData = resData.rows
      })
    },
    getDataItems () {
      const addition = this.addition
      const params = Object.fromEntries(addition.split('&').map(str => str.split('=')))
      getDataByPage({ ...this.page, ...params }).then(res => {
        const data = res.data.map.data
        this.form.name = this.currentItem.name
        this.form.total = data.total ? data.total : 20000
        this.form.count = parseInt(this.form.total * this.form.percentage / 100)
      })
    },
    handleSubmit () {
      getSplitTask({
        taskNumber: this.form.taskNum, id: this.currentItem.id, state: 'under_approval'
      }).then(res => {
        this.$message.success('审核任务已拆分，可至“查看子任务”页进行审核任务分配')
        this.visible = false
        this.$emit('refresh-data')
      })
    },
    changeHandle () {
      this.form.count = parseInt(this.form.total * this.form.percentage / 100)
      // console.log('999988', this.form.count, this.form.reviewTaskNum)
      this.form.taskNum = this.form.reviewTaskNum === 0 ? 0 : Math.ceil(this.form.count / this.form.reviewTaskNum)
    },
    handleCancel () {
      this.visible = false
    }
  }
}
</script>
<style lang="less">

</style>
